import t from '@jetshop/intl';
import Accordion from '../../ui/Accordion';
import SortOrderList from '@jetshop/ui/SortOrder/SortOrderList';
import React, { Fragment } from 'react';
import { styled } from 'linaria/react';
import { css } from 'linaria';
import { BooleanFilters } from './BooleanFilters';
import { ListAccordion } from './Mobile/ListAccordion';
import { RangeAccordion } from './Mobile/RangeAccordion';

const Title = styled('h1')`
  color: black;
  font-size: 1.125rem;
  text-align: center;
  padding: 1.5rem;
  border-bottom: 1px solid #e8e8e8;
  font-weight: 600;
`;

const Wrapper = styled('div')`
  button {
    padding: 0 1rem;
    border-width: 1px 0 0 0;
  }
`;

const boolFilters = css`
  padding: 1rem;
  label {
    margin-top: 0.5em;
  }
`;

function FilterDrawer({ filters, sortOrders, close, ...props }) {
  const listFilters = (filters || []).filter(
    filter => filter.__typename === 'ListFilter'
  );

  return (
    <section {...props}>
      {filters ? (
        <Wrapper>
          <Title>{t('Filter')}</Title>
          <Accordion single>
            {accordionProps => (
              <React.Fragment>
                <ListAccordion
                  filters={filters}
                  accordionProps={accordionProps}
                />
                <RangeAccordion
                  filters={filters}
                  accordionProps={accordionProps}
                  startingIdx={listFilters.length}
                />

                <div className={boolFilters}>
                  <BooleanFilters filters={filters} />
                </div>
              </React.Fragment>
            )}
          </Accordion>
        </Wrapper>
      ) : (
        <Fragment>
          <Title>{t('Sort by')}</Title>
          <SortOrderList sortOrders={sortOrders} />
        </Fragment>
      )}
    </section>
  );
}

export default FilterDrawer;
